import React from 'react';
import { DividerElement } from './divider.styles.js';
export const Divider = React.forwardRef((props, ref) => (React.createElement(DividerElement, { ref: ref, ...props })));
//# sourceMappingURL=divider.component.js.map